import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiDownload, FiFileText } from "react-icons/fi";
import moment from "moment";
import { EmptyState, PageHeader } from "../../components/dashboard/DashboardUI";
import { getGeneralDocuments } from "../../redux/actions/DocumentActions";

function MyDocuments() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authUser);
  const { activeCompany } = useSelector((state) => state.companies);
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    if (!user?.token || !activeCompany?._id) {
      setLoading(false);
      return;
    }

    setLoading(true);
    Promise.resolve(
      dispatch(
        getGeneralDocuments(user.token, activeCompany._id, (data) =>
          setDocuments(Array.isArray(data) ? data : []),
        ),
      ),
    ).finally(() => setLoading(false));
  }, [user?.token, activeCompany?._id, dispatch]);

  return (
    <>
      <PageHeader
        title="Mes documents"
        lead={
          activeCompany
            ? `Les documents officiels de ${activeCompany.businessName}.`
            : "Les documents officiels de votre entreprise."
        }
      />

      <div className="dash-card">
        {!activeCompany ? (
          <EmptyState title="Aucune entreprise active">
            Choisissez une entreprise en haut de la page pour voir ses
            documents.
          </EmptyState>
        ) : loading ? (
          <p className="dash-loading">Chargement des documents…</p>
        ) : documents.length === 0 ? (
          <EmptyState title="Aucun document pour le moment">
            Les documents remis par nos équipes (statuts, attestations…)
            apparaîtront ici.
          </EmptyState>
        ) : (
          <ul className="dash-list">
            {documents.map((file) => (
              <li key={file.id || file.url}>
                <div className="dash-file-row">
                  <FiFileText aria-hidden="true" />
                  <div>
                    <span className="dash-cell-title">{file.name}</span>
                    {file.createdAt && (
                      <span className="dash-cell-sub">
                        Ajouté le {moment(file.createdAt).format("DD/MM/YYYY")}
                      </span>
                    )}
                  </div>
                </div>
                <a
                  className="dash-link-button"
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FiDownload aria-hidden="true" /> Télécharger
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
}

export default MyDocuments;
